<template>
  <div class="h100 Apage">
    <filter-layout @search="doSearch" @reset="doRefresh" hasMore>
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchForm"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="绑定企业：" prop="sname">
            <el-input
              v-model="searchForm.sname"
              placeholder="请输入企业名称"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码："
            prop="code"
            label-width="160px"
          >
            <el-input
              v-model="searchForm.code"
              placeholder="请输入"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行：" prop="bank">
            <el-select v-model="searchForm.bank">
              <el-option
                v-for="(item, index) in khh"
                :key="'khh' + index"
                :label="item.sname"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户类型：" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择"
              size="small"
            >
              <el-option :value="0" label="对公账户"></el-option>
              <el-option :value="1" label="个人银行卡"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #more>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchForm"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="创建人：" prop="createUser">
            <el-input
              v-model="searchForm.createUser"
              placeholder="请输入"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间：" prop="dateRange" label-width="160px">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              size="small"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="content-header">
          <div class="title">
            合计绑定账户：<span class="blue">{{ tableObj.total }}</span> 个
          </div>
          <div class="btnGroups">
            <el-button size="small" type="success" @click="addAccount"
              >添加法人提现账户</el-button
            >
            <el-button
              class="btn-blue ml10"
              icon="el-icon-refresh"
              @click="doRefresh"
              size="small"
            ></el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page">
          <div class="w-table-content" v-show="tableObj.show" ref="table">
            <vxe-table
              ref="xTable"
              :data="tableObj.tableData"
              highlight-current-row
              highlight-hover-row
              border
              height="100%"
              size="small"
              auto-resize
              sync-resize
              resizable
              align="center"
              show-overflow="tooltip"
              show-header-overflow="tooltip"
            >
              <vxe-table-column
                type="seq"
                title="序号"
                width="55px"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="bankName"
                title="开户银行"
                width="130px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="sname"
                title="开行户名称"
                width="150px"
                header-align="center"
              >
                <template #default="{ row }">
                  <span>{{ row.type === 1 ? row.legaler : row.sname }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="account"
                title="银行账户"
                width="160px"
                header-align="center"
                align="left"
              >
              </vxe-table-column>
              <vxe-table-column
                field="type"
                title="账户类型"
                width="100px"
                header-align="center"
              >
                <template #default="{ row }">
                  <span>{{ row.type === 1 ? "个人银行卡" : "对公账户" }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="branchBank"
                title="开户行支行名称"
                width="160px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="payNo"
                title="支付行行号"
                width="120px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="sname"
                title="绑定企业"
                min-width="170px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="createUser"
                title="创建人"
                width="100px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="createDate"
                title="创建时间"
                width="160px"
                header-align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="isDefault"
                title="是否默认提现账户"
                width="140px"
                header-align="center"
              >
                <template #default="{ row }">
                  <span>{{ row.isDefault === 1 ? "是" : "否" }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="status"
                title="账户状态控制"
                width="110px"
                header-align="center"
              >
                <template #default="{ row }">
                  <template v-if="row.type === 1">
                    <vxe-switch
                      v-model="row.status"
                      :open-value="0"
                      open-label="启用"
                      :close-value="1"
                      close-label="关闭"
                      @change="changeState($event, row)"
                    ></vxe-switch>
                  </template>
                  <template v-else>
                    <span>-</span>
                  </template>
                </template>
              </vxe-table-column>
              <vxe-table-column title="操作" width="90px" align="center">
                <template v-slot="{ row }">
                  <el-button
                    round
                    plain
                    class="table-btn"
                    type="primary"
                    size="small"
                    @click="showDetail(row)"
                  >
                    <svg-icon icon-class="form-look"></svg-icon> 查看
                  </el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="w-table-footer">
            <vxe-pager
              align="center"
              size="mini"
              :current-page="searchForm.current"
              :page-size="searchForm.size"
              :total="tableObj.total"
              :layouts="[
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'FullJump',
                'Sizes',
                'Total',
              ]"
              @page-change="handlePageChange"
            ></vxe-pager>
          </div>
        </div>
      </template>
    </filter-layout>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogObj.visible"
      :title="dialogObj.title"
      :width="dialogObj.width"
      :close-on-click-modal="false"
      @closed="handleClosed"
      center
    >
      <!-- 新增法人 -->
      <template v-if="dialogObj.type === 'add'">
        <h4 class="red-text">
          请确保填写银行卡（借记卡）号为法人本人的，手机号为银行卡办理时的手机号，否则验证将通不过
        </h4>
        <el-form
          :model="addForm"
          ref="addForm"
          :rules="addRules"
          label-width="170px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="绑定企业：" prop="bizUserid">
                <el-select
                  v-model="addForm.bizUserid"
                  @change="changeCompany"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="(item, index) in companyList"
                    :key="'companyList' + index"
                    :value="item.bizUserid"
                    :label="item.sname"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码：" prop="code">
                <el-input disabled v-model="addForm.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人代表姓名：" prop="name">
                <el-input disabled v-model="addForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人代表身份证号码：" prop="identityNo">
                <el-input v-model="addForm.identityNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行：" prop="bank">
                <el-select v-model="addForm.bank" filterable>
                  <el-option
                    v-for="(item, index) in khh"
                    :key="'khh' + index"
                    :label="item.sname"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行卡号：" prop="cardNo">
                <el-input v-model="addForm.cardNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行卡预留手机号：" prop="phone">
                <el-input v-model="addForm.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <!-- 查看详情 -->
      <template v-if="dialogObj.type === 'view'">
        <el-row class="info-row">
          <el-col :span="12">开户银行： {{ currentRow.bankName }}</el-col>
          <el-col :span="12"
            >开行户名称：
            {{
              currentRow.type === 1 ? currentRow.legaler : currentRow.sname
            }}</el-col
          >
          <el-col :span="12">银行账户： {{ currentRow.account }}</el-col>
          <el-col :span="12"
            >账户类型：
            {{ currentRow.type === 1 ? "个人银行卡" : "对公账户" }}</el-col
          >
          <template v-if="currentRow.type === 1">
            <el-col :span="12">法人身份证号： {{ currentRow.idCard }}</el-col>
            <el-col :span="12"
              >银行卡预约手机号： {{ currentRow.phone }}</el-col
            >
          </template>
          <template v-else>
            <el-col :span="12"
              >开户行支行名称： {{ currentRow.branchBank }}</el-col
            >
            <el-col :span="12">支付行行号： {{ currentRow.payNo }}</el-col>
          </template>
          <el-col :span="12">绑定企业： {{ currentRow.sname }}</el-col>
          <el-col :span="12">统一社会信用代码： {{ currentRow.code }}</el-col>
          <el-col :span="12">创建人： {{ currentRow.createUser }}</el-col>
          <el-col :span="12">创建时间： {{ currentRow.createDate }}</el-col>
        </el-row>
      </template>

      <!-- footer 组件 -->
      <div
        slot="footer"
        class="pdb10 text-center"
        v-if="dialogObj.type !== 'view'"
      >
        <el-button size="small" class="btn" @click="dialogObj.visible = false"
          >取 消
        </el-button>
        <el-button
          type="primary"
          size="small"
          :loading="dialogObj.btnLoading"
          class="btn btn-blue"
          @click="doSubmit"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// api
import {
	bindBankCard,
	selectAccountSubPage,
	selectCompanySub,
	setAccountSubStatus,
} from "api/modules/account";
// 引入js
import { mapState } from "vuex";

export default {
  name: "about_account",
  data() {
    return {
      searchToggle: true, // 切换展示 筛选条件
      // 查询
      searchForm: {
        size: 10,
        current: 1,
        sname: "",
        code: "",
        bank: "",
        type: "",
        createUser: "",
        dateRange: [],
        dateStart: "",
        dateEnd: "",
      },
      // 表格
      tableObj: {
        show: true,
        tableData: [],
        total: 0,
        loading: false,
      },
      // 弹窗
      dialogObj: {
        visible: false,
        title: "",
        width: "1000px",
        type: "add",
        btnLoading: false,
      },
      // 添加数据
      addForm: {
        bizUserid: "",
        code: "",
        name: "",
        identityNo: "",
        bank: "",
        cardNo: "",
        phone: "",
      },
      addRules: {
        bizUserid: [
          {
            required: true,
            message: "企业名称不能为空",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "法人代表姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        identityNo: [
          {
            required: true,
            message: "法定代表人身份证号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        bank: [
          {
            required: true,
            message: "开户银行不能为空",
            trigger: "change",
          },
        ],
        cardNo: [
          {
            required: true,
            message: "银行卡号不能为空",
            trigger: "blur",
          },
          {
            // pattern: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
            pattern: /^[0-9]{13,19}$/,
            message: "请输入正确的银行卡号！",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "银行卡预留手机号",
            trigger: "blur",
          },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号码格式有误！",
            trigger: "blur",
          },
        ],
      },
      // 当前行对象
      currentRow: {},
      // 绑定的公司列表
      companyList: [],
    };
  },
  created() {
    this.doSearch();

    // 获取公司
    this.getAccountList();
  },
  methods: {
    // 分页查询列表
    doSearch(page) {
      page ? (this.searchForm.current = parseInt(page)) : "";
      let params = this.$utils.clone(this.searchForm, true);

      if (params.dateRange.length > 0) {
        params.dateStart = params.dateRange[0] + " 00:00:00";
        params.dateEnd = params.dateRange[1] + " 23:59:59";
      }

      selectAccountSubPage(params)
        .then((res) => {
          this.tableObj.tableData = res.data.records;
          this.tableObj.total = parseInt(res.data.total);
        })
        .catch((err) => {
          this.tableObj.tableData = [];
          this.tableObj.total = 0;
        });
    },

    // 重置
    doRefresh() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        size: 10,
        current: 1,
        sname: "",
        code: "",
        bank: "",
        type: "",
        createUser: "",
        dateRange: [],
        dateStart: "",
        dateEnd: "",
      };
      this.doSearch(1);
    },

    // 添加法人提现账户
    addAccount() {
      this.dialogObj.visible = true;
      this.dialogObj.title = "新增企业法人提现账户";
      this.dialogObj.type = "add";

      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.addForm ? this.$refs.addForm.clearValidate() : "";
        }, 0);
      });
    },

    // 查看详情
    showDetail(row) {
      this.currentRow = this.$utils.clone(row, true);

      this.dialogObj.visible = true;
      this.dialogObj.title = "查看详细";
      this.dialogObj.type = "view";
    },

    // 查询账户列表
    getAccountList() {
      selectCompanySub({})
        .then((res) => {
          this.companyList = res.data;
        })
        .catch((err) => {
          this.companyList = [];
        });
    },

    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.searchForm.size = pageSize;
      this.searchForm.current = currentPage;
      this.doSearch();
    },

    // 切换绑定企业
    changeCompany(val) {
      let _item = this.companyList.find((x) => x.bizUserid === val);
      if (_item) {
        this.addForm.code = _item.code;
        this.addForm.name = _item.legaler;
        this.addForm.identityNo = _item.idCard;
      } else {
        this.addForm.code = "";
        this.addForm.name = "";
        this.addForm.identityNo = "";
      }
    },

    // 切换账户状态
    changeState({ value }, row) {
      setAccountSubStatus({ id: row.id, status: value })
        .then((res) => {
          this.$message.success("状态切换成功！");

          this.doSearch();
        })
        .catch((err) => {
          row.status = value === 1 ? 0 : 1;
        });
    },

    // 弹窗确认添加法人
    doSubmit() {
      this.dialogObj.btnLoading = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = false;

          let params = this.$utils.clone(this.addForm, true);
          params.createUser = this.userInfo.sname;
          bindBankCard(params)
            .then((res) => {
              this.$message.success("绑定成功！");
              this.dialogObj.btnLoading = false;

              // 关闭弹窗
              this.handleClosed();

              // 查询
              this.doSearch(1);
            })
            .catch((err) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          setTimeout(() => {
            this.dialogObj.btnLoading = false;
          }, 1000);
        }
      });
    },

    // 弹窗关闭  清除
    handleClosed() {
      this.dialogObj.visible = false;

      this.addForm.bizUserid = "";
      this.addForm.code = "";
      this.addForm.name = "";
      this.addForm.identityNo = "";
      this.addForm.bank = "";
      this.addForm.cardNo = "";
      this.addForm.phone = "";
    },
  },
  computed: {
    ...mapState("user", {
      userInfo: (state) => state.userInfo,
    }),
    ...mapState("dict", {
      khh: (state) => state.projectDict.khh,
    }),
    ...mapState("menu", {
      roleBtns: (state) => state.roleBtns,
    }),
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableObj.show = false;
      setTimeout(() => {
        this.tableObj.show = true;
      }, 50);
    },
  },
};
</script>
<style lang="less" scoped>
.red-text {
  color: red;
  padding: 0 10px;
  line-height: 30px;
  background-color: #eee;
  margin-bottom: 20px;
}
.info-row {
  padding: 10px 30px;
  line-height: 30px;
}
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  .title {
    padding-left: 10px;
    border-left: 4px solid #2671cc;
    font-size: 14px;
    color: #202020;
  }
  .blue {
    font-size: 18px;
    color: #2671cc;
  }
}
</style>
